import React, { Component } from 'react';
import queryString from 'query-string';
import withContext from 'modules/utils/cp3/hoc/withContext';

const {
	Provider: AuthContextProvider,
	Consumer: AuthConsumer,
} = React.createContext();
const withAuthContext = withContext(AuthConsumer);

class AuthProvider extends Component {
	constructor(props) {
		super(props);

		const queryParams = queryString.parse(window.location.search);
		this.userToken = queryParams.token || '';
	}

	state = {
		username: '',
	};

	updateContext = newContext => {
		this.setState(newContext);
	};

	updateUsername = username => {
		this.setState({
			username,
		});
	};

	render() {
		const contextValue = {
			...this.state,
			userToken: this.userToken,
			updateContext: this.updateContext,
			updateUsername: this.updateUsername,
		};

		return (
			<AuthContextProvider value={contextValue}>
				{this.props.children}
			</AuthContextProvider>
		);
	}
}

export { AuthProvider, AuthConsumer, withAuthContext };
